export default __webpack_public_path__ + "static/media/007-knot-1.b0aea1b2.png";